import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Card, Stack } from "react-bootstrap";
import { FaCircle } from "react-icons/fa";

const StackedBarChart = ({ colors, data = {} }) => {
  // Defining the series data for the bar chart
  const [seriesData, setSeriesData] = useState([
    {
      name: "Informed RIDDOR",
      data: [],
      color: colors[0],
    },
    {
      name: "Went to Hospital",
      data: [],
      color: colors[1],
    },
    {
      name: "Minor",
      data: [],
      color: colors[2],
    },
  ]);

  // Chart options
  const [options, setOptions] = useState({
    dataLabels: { enabled: false },
    chart: {
      type: "bar",
      stacked: true,
      toolbar: { show: false },
      zoom: { enabled: true },
    },
    colors,
    responsive: [{ breakpoint: 480 }],
    xaxis: {
      type: "category",
      categories: [],
      labels: { style: { colors: "#A8A8BD", fontSize: "14px" } },
    },
    yaxis: {
      min: 0,
      max: 0,
      labels: {
        formatter: (val) => val.toFixed(0),
        style: { colors: "#A8A8BD", fontSize: "14px" },
      },
      tooltip: { enabled: false },
    },
    legend: { show: false },
    grid: { borderColor: "#A8A8BD", strokeDashArray: 4 },
    plotOptions: { bar: {} },
  });

  const findMaxIndex = (arr1, arr2, arr3) => {
    const maxLength = [arr1, arr2, arr3].reduce(
      (max, arr) => Math.max(max, arr.length),
      0
    );

    const sumArray = [];

    for (let i = 0; i < maxLength; i++) {
      const sum = arr1[i] + arr2[i] + arr3[i];
      sumArray.push(sum);
    }
    const maxNumber = Math.max(...sumArray);
    return maxNumber;
  };

  // Effect to update the chart when data changes
  useEffect(() => {
    if (!data || Object.keys(data).length === 0) return;

    const categories = data?.months ?? [];
    const maxNumber = findMaxIndex(
      data?.informed_RIDDOR ?? [],
      data?.went_to_hospital ?? [],
      data?.minor ?? []
    );

    // Update series data only if it has changed
    const newData = [
      {
        name: "Informed RIDDOR",
        data: data?.informed_RIDDOR ?? [],
        color: colors[0],
      },
      {
        name: "Went to Hospital",
        data: data?.went_to_hospital ?? [],
        color: colors[1],
      },
      {
        name: "Minor",
        data: data?.minor ?? [],
        color: colors[2],
      },
    ];
    setSeriesData(newData);
    setOptions((prevOptions) => {
      return {
        ...prevOptions,
        xaxis: {
          ...prevOptions.xaxis,
          categories: categories,
        },
        yaxis: {
          ...prevOptions.yaxis,
          max: maxNumber,
        },
      };
    });
  }, [data, colors]);

  return (
    <Card className="dashboard_cards h-100" style={{ border: "none" }}>
      <Card.Body className="d-flex flex-column gap-3">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
          <Card.Title className="text_gray mb-0">
            Number of Incidents
          </Card.Title>
          <Stack direction="horizontal" className="gap-3 flex-wrap">
            {seriesData.map((item, index) => (
              <Stack
                direction="horizontal"
                className="column-gap-2"
                key={index}
              >
                <FaCircle color={item.color} size={10} />
                <p
                  className="m-0"
                  style={{ color: "#A8A8BD", lineHeight: 1, fontWeight: 400 }}
                >
                  {item.name}
                </p>
              </Stack>
            ))}
          </Stack>
        </div>
        <div id="incident-chart">
          <ReactApexChart
            options={options}
            series={seriesData}
            type="bar"
            height={300}
            width="100%"
          />
        </div>
      </Card.Body>
    </Card>
  );
};

export default StackedBarChart;
